



















































































































import {Vue, Component} from "vue-property-decorator";

import RiskComponent from "../components/RiskComponent.vue";
import Tooltip from "../components/Tooltip.vue";
import RiskPrioritizationFooter from "../components/RiskPrioritizationFooter.vue";
import RiskPrint from "@/components/RiskPrint.vue";
import {SurveyTabType} from "@/types/surveyTab.type";
import {SurveyTabCollectionType} from "@/types/surveyComponent.type";
import {
    RiskItemType,
    RiskTableType,
    ScaleDictType
} from "@/types/riskPrioritization.type";
import {CSVExportType} from "@/types/csvExport.type";

@Component({
    components: {
        RiskComponent,
        Tooltip,
        RiskPrioritizationFooter,
        RiskPrint
    }
})
export default class RiskPrioritization extends Vue {
    page = 1;
    pageCount = 0;
    itemsPerPage = 2;

    riskOrder: number[] = [];
    riskSort = false;
    componentSort = false;

    items: RiskItemType[] = [
        {
            name: this.surveyTabs[1].name,
            id: this.surveyTabs[1].step,
            store: this.voterRegQuestions,
            show: !this.surveyTabs[1].hideStep
        },
        {
            name: this.surveyTabs[2].name,
            id: this.surveyTabs[2].step,
            store: this.pollbookPrepQuestions,
            show: !this.surveyTabs[2].hideStep
        },
        {
            name: this.surveyTabs[3].name,
            id: this.surveyTabs[3].step,
            store: this.pollbookUseQuestions,
            show: !this.surveyTabs[3].hideStep
        },
        {
            name: this.surveyTabs[4].name,
            id: this.surveyTabs[4].step,
            store: this.ballotPrepQuestions,
            show: !this.surveyTabs[4].hideStep
        },
        {
            name: this.surveyTabs[5].name,
            id: this.surveyTabs[5].step,
            store: this.votingMachinePrepQuestions,
            show: !this.surveyTabs[5].hideStep
        },
        {
            name: this.surveyTabs[6].name,
            id: this.surveyTabs[6].step,
            store: this.votingMachineUseQuestions,
            show: !this.surveyTabs[6].hideStep
        },
        {
            name: this.surveyTabs[7].name,
            id: this.surveyTabs[7].step,
            store: this.tabPrepQuestions,
            show: !this.surveyTabs[7].hideStep
        },
        {
            name: this.surveyTabs[8].name,
            id: this.surveyTabs[8].step,
            store: this.precinctTabulationQuestions,
            show: this.showPrecinctTabulation
        },
        {
            name: this.surveyTabs[9].name,
            id: this.surveyTabs[9].step,
            store: this.centralTabulationQuestions,
            show: !this.surveyTabs[9].hideStep
        },
        {
            name: this.surveyTabs[10].name,
            id: this.surveyTabs[10].step,
            store: this.aggregationQuestions,
            show: !this.surveyTabs[10].hideStep
        },
        {
            name: this.surveyTabs[11].name,
            id: this.surveyTabs[11].step,
            store: this.websiteQuestions,
            show: !this.surveyTabs[11].hideStep
        }
    ];

    labels = {
        confidentiality: "Confidentiality",
        integrity: "Integrity",
        availability: "Availability"
    };
    riskTableItems: RiskTableType[] = [];

    dataBlob: null | Blob = null;
    dataDownload: null | string = null;
    csvFileName = "ESRPT_Results.csv";

    mounted() {
        this.riskTableItems = this.getRiskTableItems();
        this.createCSVDownload();
    }

    get showPrecinctTabulation(): boolean {
        if (
            this.precinctTabulationQuestions.scaleQuestions.questions
                .tabulationAtPrecincts.userInput.answer === "No" ||
            this.surveyTabs[8].hideStep
        ) {
            return false;
        } else return true;
    }

    get voterRegQuestions(): SurveyTabType {
        return this.$store.getters.voterRegistrationQuestions;
    }
    get pollbookPrepQuestions(): SurveyTabType {
        return this.$store.getters.pollbookPrepQuestions;
    }
    get pollbookUseQuestions(): SurveyTabType {
        return this.$store.getters.pollbookUseQuestions;
    }
    get ballotPrepQuestions(): SurveyTabType {
        return this.$store.getters.ballotPrepQuestions;
    }
    get votingMachinePrepQuestions(): SurveyTabType {
        return this.$store.getters.votingMachinePrepQuestions;
    }

    get votingMachineUseQuestions(): SurveyTabType {
        return this.$store.getters.votingMachineUseQuestions;
    }

    get tabPrepQuestions(): SurveyTabType {
        return this.$store.getters.tabulationPrepQuestions;
    }

    get precinctTabulationQuestions(): SurveyTabType {
        return this.$store.getters.precinctTabulationQuestions;
    }

    get centralTabulationQuestions(): SurveyTabType {
        return this.$store.getters.centralTabulationQuestions;
    }

    get aggregationQuestions(): SurveyTabType {
        return this.$store.getters.aggregationQuestions;
    }

    get websiteQuestions(): SurveyTabType {
        return this.$store.getters.websiteQuestions;
    }

    get surveyTabs(): SurveyTabCollectionType {
        return this.$store.getters.surveyTabs;
    }

    get isIE(): boolean {
        return this.$store.getters.isIE;
    }

    get websiteVisited(): boolean {
        return this.$store.getters.websiteVisited;
    }

    get aggregationVisited(): boolean {
        return this.$store.getters.aggregationVisited;
    }

    sortOrder() {
        if (this.componentSort === true) {
            this.componentSort = false;
        }

        this.riskSort = !this.riskSort;

        if (this.riskSort) {
            this.riskTableItems.sort((a: any, b: any): any => {
                return a.order > b.order ? 1 : -1;
            });
        } else {
            this.riskTableItems.sort((a: any, b: any): any => {
                return a.order < b.order ? 1 : -1;
            });
        }

        return this.riskTableItems;
    }
    sortComponent() {
        if (this.riskSort === true) {
            this.riskSort = false;
        }

        this.componentSort = !this.componentSort;
        if (this.componentSort) {
            this.riskTableItems.sort((a: any, b: any): any => {
                return a.name > b.name ? 1 : -1;
            });
        } else {
            this.riskTableItems.sort((a: any, b: any): any => {
                return a.name < b.name ? 1 : -1;
            });
        }

        return this.riskTableItems;
    }

    print() {
        window.print();
    }

    getRiskTableItems() {
        const array: RiskTableType[] = [];
        const valuesArray: number[] = [];
        this.items.forEach((item: RiskItemType) => {
            if (item.show) {
                const individualScores = {
                    confidentiality: this.calculateRiskPriority(
                        "confidentiality",
                        item.store,
                        item.name
                    ),
                    integrity: this.calculateRiskPriority(
                        "integrity",
                        item.store,
                        item.name
                    ),
                    avaialability: this.calculateRiskPriority(
                        "availability",
                        item.store,
                        item.name
                    )
                };
                const averageRiskScore =
                    (individualScores.confidentiality! +
                        individualScores.avaialability! +
                        individualScores.integrity!) /
                    3;
                valuesArray.push(averageRiskScore);
                array.push({
                    name: item.name,
                    id: item.id,
                    question: item.store,
                    order: 0,
                    scale:
                        item.store.scaleQuestions.questions.scale.userInput
                            .answer,
                    unformattedRiskScore: averageRiskScore,
                    avgRiskScore: this.formatRiskScore(averageRiskScore),
                    labels: this.labels,
                    riskScore: {
                        confidentiality: this.formatRiskScore(
                            individualScores.confidentiality!
                        ),
                        integrity: this.formatRiskScore(
                            individualScores.integrity!
                        ),
                        availability: this.formatRiskScore(
                            individualScores.avaialability!
                        )
                    },
                    capability: {
                        confidentiality: this.calculateConfidentialityAndIntegrityTier(
                            item.store,
                            item.name
                        ),
                        integrity: this.calculateConfidentialityAndIntegrityTier(
                            item.store,
                            item.name
                        ),
                        availability: this.calculateAvailabilityTier(item.store)
                    },
                    importance: {
                        confidentiality:
                            item.store.importanceQuestions.questions
                                .confidentiality.userInput.userValue,
                        integrity:
                            item.store.importanceQuestions.questions.integrity
                                .userInput.userValue,

                        availability:
                            item.store.importanceQuestions.questions
                                .availability.userInput.userValue
                    }
                });
            }
        });
        // Assign unformatted score of 0 if isNan
        array.forEach((item: RiskTableType) => {
            if (isNaN(item.unformattedRiskScore)) {
                item.unformattedRiskScore = 0;
            }
        });

        // Sort in decending order by risk score
        array.sort(function(a, b) {
            return b.unformattedRiskScore - a.unformattedRiskScore;
        });

        // // Add in order numbers
        array.forEach(function(item, index) {
            item.order = index + 1;
        });

        return array;
    }

    // Sets the risk order for confidentiality attack type.
    getRiskOrder(avgRisk: number, valuesArray: number[]): number {
        let order = 0;
        const total = 0;

        // add in ranks
        valuesArray.forEach((num: number, index: number) => {
            if (this.formatRiskScore(num) === this.formatRiskScore(avgRisk)) {
                order = index + 1;
            }
        });
        return order;
    }

    formatRiskScore(value: number) {
        const formattedScore =
            !isNaN(Math.round(value * 10) / 10) && value !== 0
                ? Math.round(value * 10) / 10
                : "--";
        return formattedScore;
    }

    calculateConfidentialityAndIntegrityTier(
        question: SurveyTabType,
        name: string
    ) {
        if (name === "Website" && this.websiteVisited == false) {
            return 0;
        } else if (
            name === "Aggregation (State)" &&
            this.aggregationVisited === false
        ) {
            return 0;
        } else {
            const authQuestions = question.authQuestions.questions;
            const hardwareQuestions = question.hardwareQuestions.questions;
            const softwareQuestions = question.softwareQuestions.questions;
            const accessQuestions = question.accessQuestions.questions;

            const authentication =
                authQuestions.anyAuth.userInput.answer === "Yes" ||
                authQuestions.sfa.userInput.answer === "Yes" ||
                authQuestions.mfa.userInput.answer === "No"
                    ? 3
                    : authQuestions.tfa.userInput.answer === "Yes"
                    ? 2
                    : 1;

            const remoteAccess =
                accessQuestions.remoteAccess.userInput.answer === "No" ||
                accessQuestions.remoteAccess.userInput.answer === null
                    ? 0
                    : accessQuestions.remoteAccessNoAuth.userInput.answer ===
                          "Yes" ||
                      accessQuestions.anyIPS.userInput.answer === "No"
                    ? 3
                    : accessQuestions.allowList.userInput.answer === "No"
                    ? 2
                    : 1;

            const physicalMedia =
                accessQuestions.physicalMedia.userInput.answer === "No" ||
                accessQuestions.physicalMedia.userInput.answer === null
                    ? 0
                    : accessQuestions.removableMediaPolicy.userInput.answer ===
                      "No"
                    ? 2
                    : 1;

            const proximateAccess =
                accessQuestions.proximateAccess.userInput.answer === "No" ||
                accessQuestions.proximateAccess.userInput.answer === null
                    ? 0
                    : accessQuestions.bluetooth.userInput.answer === "Yes" ||
                      accessQuestions.wepOrWpa1.userInput.answer === "Yes" ||
                      accessQuestions.wpa2.userInput.answer === "No"
                    ? 3
                    : 2;

            const patchHardware =
                name === this.surveyTabs[1].name ||
                name === this.surveyTabs[11].name
                    ? hardwareQuestions.patchHardware.userInput.answer === "No"
                        ? 3
                        : hardwareQuestions.patchHardwareElection.userInput
                              .answer === "Yes"
                        ? 1
                        : 2
                    : hardwareQuestions.patchHardware.userInput.answer === "No"
                    ? 3
                    : hardwareQuestions.patchHardwareElection.userInput
                          .answer === "Yes"
                    ? 1
                    : 2;

            const patchSoftware =
                name === this.surveyTabs[1].name ||
                name === this.surveyTabs[11].name
                    ? softwareQuestions.patchSoftware.userInput.answer === "No"
                        ? 3
                        : softwareQuestions.patchSoftwareElection.userInput
                              .answer === "Yes"
                        ? 1
                        : 2
                    : softwareQuestions.patchSoftware.userInput.answer === "No"
                    ? 3
                    : softwareQuestions.patchSoftwareElection.userInput
                          .answer === "Yes"
                    ? 1
                    : 2;

            const patching = Math.max(patchHardware, patchSoftware);
            const calc1 = Math.max(authentication, patching);
            const calc2 = Math.max(
                remoteAccess,
                physicalMedia,
                proximateAccess
            );
            // Calculate to find the min of the different sets.
            const tierLevel = Math.min(calc1, calc2);

            return tierLevel;
        }
    }

    calculateAvailabilityTier(question: SurveyTabType) {
        const authQuestions = question.authQuestions.questions;
        const hardwareQuestions = question.hardwareQuestions.questions;
        const softwareQuestions = question.softwareQuestions.questions;
        const accessQuestions = question.accessQuestions.questions;
        const ddosQuestions = question.ddosQuestions.questions;
        // Logic for getting the proximate access value.
        const proximateAccess =
            accessQuestions.proximateAccess.userInput.answer === "No" ||
            accessQuestions.proximateAccess.userInput.answer === null
                ? 0
                : accessQuestions.bluetooth.userInput.answer === "Yes" ||
                  accessQuestions.wepOrWpa1.userInput.answer === "Yes" ||
                  accessQuestions.wpa2.userInput.answer === "No"
                ? 3
                : 2;
        // Logic for getting the ddos value.
        const noDDosProtection =
            3 *
            (ddosQuestions.ddosProtection.userInput.answer === "No" ? 1 : 0);
        const hasDDosProtection =
            2 *
            (ddosQuestions.ddosProtection.userInput.answer === "Yes" ? 1 : 0);
        const DDosNull =
            ddosQuestions.ddosProtection.userInput.answer === null ? 1 : 0;
        // Logic for getting the remote access value.
        const remoteAccess =
            accessQuestions.remoteAccess.userInput.answer === "Yes"
                ? Math.max(
                      Math.max(noDDosProtection, hasDDosProtection, DDosNull),
                      2,
                      1
                  )
                : 0;
        // Logic for getting the physical media value.
        const noRemovableMediaPolicy =
            2 *
            (accessQuestions.removableMediaPolicy.userInput.answer === "No"
                ? 1
                : 0);
        const hasRemovableMediaPolicy =
            accessQuestions.removableMediaPolicy.userInput.answer === "Yes"
                ? 1
                : 0;
        const physicalMedia =
            accessQuestions.physicalMedia.userInput.answer === "Yes"
                ? Math.max(noRemovableMediaPolicy, hasRemovableMediaPolicy)
                : 0;
        // Calculates the max of the various values.
        const availabilityTier = Math.max(
            proximateAccess,
            remoteAccess,
            physicalMedia
        );
        return availabilityTier;
    }

    calculateRiskPriority(
        attackType: string,
        question: SurveyTabType,
        name: string
    ) {
        const authQuestions = question.authQuestions.questions;
        const hardwareQuestions = question.hardwareQuestions.questions;
        const softwareQuestions = question.softwareQuestions.questions;
        const accessQuestions = question.accessQuestions.questions;
        const importanceQuestions = question.importanceQuestions.questions;

        const scaleDict: ScaleDictType = {
            High: 3,
            Medium: 2,
            Low: 1
        };
        let tierRating;
        // Sets the tier rating based on the attack type.
        if (attackType == "confidentiality" || attackType == "integrity") {
            tierRating = this.calculateConfidentialityAndIntegrityTier(
                question,
                name
            );
        } else {
            tierRating = this.calculateAvailabilityTier(question);
        }

        // Sets the scale.
        const scaleRating =
            question.scaleQuestions.questions.scale.userInput.answer;

        // Sets the importance value based on the attack type.
        const type =
            attackType == "confidentiality"
                ? importanceQuestions.confidentiality
                : attackType == "integrity"
                ? importanceQuestions.integrity
                : importanceQuestions.availability;

        const importance = type.userInput.userValue;

        // Multiplies the tier rating, scale and importance level to get a value for determining the level of risk.
        if (scaleRating != null) {
            return tierRating * scaleDict[scaleRating] * importance;
        }
    }

    createCSVDownload() {
        const csvData: CSVExportType[] = [
            {
                prioritization: "Prioritization",
                tabName: "Election Security Survey Component",
                avgRiskScore: "Average Risk Score",
                scale: "Scale",
                confRisk: "Confidentiality - Risk Score",
                confCapability: "Confidentiality - Capability",
                confImportance: "Confidentiality - Importance",
                integRisk: "Integrity - Risk Score",
                integCapability: "Integrity - Capability",
                integImportance: "Integrity - Importance",
                availRisk: "Availability - Risk Score",
                availCapability: "Availability - Capability",
                availImportance: "Availability - Importance"
            }
        ];

        const rows: string[][] = [];

        this.riskTableItems.forEach(element => {
            csvData.push({
                prioritization: element.order,
                tabName: element.name,
                avgRiskScore: element.avgRiskScore,
                scale: element.scale,
                confRisk: element.riskScore.confidentiality,
                confCapability: element.capability.confidentiality,
                confImportance: element.importance.confidentiality,
                integRisk: element.riskScore.integrity,
                integCapability: element.capability.integrity,
                integImportance: element.importance.integrity,
                availRisk: element.riskScore.availability,
                availCapability: element.capability.availability,
                availImportance: element.importance.availability
            });
        });

        csvData.forEach(object => {
            rows.push(Object.values(object));
        });

        const csvContent = rows.map(e => e.join(",")).join("\n");

        this.dataBlob = new Blob([csvContent], {
            type: "text/csv"
        });

        this.dataDownload = URL.createObjectURL(this.dataBlob);
    }

    saveCSV() {
        window.navigator.msSaveBlob(this.dataBlob, this.csvFileName);
    }
}
